import { useMemo } from 'react';

import type { Capabilities } from '@rtkwlf/rendall';
import { useQuery } from '@tanstack/react-query';

import { hasAnyRequiredProperty } from '@packages/utils/has-any-required-property';

import { capabilitiesQuery } from '../queries/capabilities';

/** @experimental For application using `@platform` only. */
export const useHasLegacyCapabilities = (
  organizationId: string,
  capabilities: Partial<Capabilities>,
) => {
  const { data, isLoading } = useQuery(capabilitiesQuery(organizationId));

  return useMemo(() => {
    if (!data || isLoading) return null;
    return hasAnyRequiredProperty(capabilities, data);
  }, [data, isLoading, capabilities]);
};
